import { Suspense, type FC, type ReactNode, lazy } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState';

const ServerSafeSuspense: FC<{ children: ReactNode }> = ({ children }) => {
    const isClient = useClientState();
    return isClient ? <Suspense fallback="">{children}</Suspense> : null;
};

const RecentlyViewed = lazy(
    () => import(/* webpackChunkName: "RecentlyViewed" */ './RecentlyViewed')
);

export const RecentlyViewedLazy: FC = props => (
    <ServerSafeSuspense>
        <RecentlyViewed {...props} />
    </ServerSafeSuspense>
);
